
import { Vue, Component, Prop } from 'vue-property-decorator';
import { getRandomIntInclusive, useFormatTimestamp } from '@/features/common/helpers';
import { UserItemType } from '@/features/users/types';
import { colors } from '@/features/common/raw';

@Component
export default class UserItem extends Vue {
  @Prop({ required: true }) user!: UserItemType;

  @Prop({ required: false, default: false }) isDisabled!: boolean;

  @Prop({ required: false, default: false }) isInvited!: boolean;

  @Prop({ required: false, default: false }) isAdmin!: boolean;

  private isRemoving = false;

  private isInviteLoading = false;

  private useFormatTimestamp = useFormatTimestamp;

  get nameInitials(): string {
    let nameInitials = this.user.firstName[0];
    if (this.user.lastName) {
      nameInitials = `${nameInitials}${this.user.lastName[0]}`;
    }
    return nameInitials.toUpperCase();
  }

  // eslint-disable-next-line class-methods-use-this
  get profileColor(): string {
    return colors[getRandomIntInclusive(0, colors.length - 1)];
  }

  private resendInvitation() {
    this.$emit('resend', this.user);

    this.isInviteLoading = true;
    setTimeout(() => {
      this.isInviteLoading = false;
    }, 4000);
  }
}
